import { AdditionalCharge } from 'services/checkout-service/models';

export const getSurchargeAmountForTotal = (surchargeRate = 0, subtotal = 0) => surchargeRate * subtotal;

export const getSurchargePercentageString = (surchargeRate = 0) => (surchargeRate * 100).toFixed(2);

type AmountAndRate = {
  amount: number;
  rate: number;
  chargeType: 'CONVENIENCE_FEE' | 'CREDIT_SURCHARGE';
};

export const getAmountAndRateFromAdditionalCharges = (
  additionalCharges: AdditionalCharge[],
  additionalChargeType = ['CREDIT_SURCHARGE' , 'CONVENIENCE_FEE']
): (AmountAndRate | undefined) => {
  const additionalCharge = additionalCharges.find(({ type }) => additionalChargeType.includes(type));

  return additionalCharge
    ? {
      amount: additionalCharge.amount,
      // Convert to percentage value
      chargeType: additionalCharge.type,
      rate: ( additionalCharge?.rate || 0 ) / 1e4,
    } : undefined;
};
